import gettext from '@sdk/lang/gettext';

import { useConversationPersonas } from '@web/conversations/Conversation/ConversationProvider/hooks/useConversationPersonas/useConversationPersonas';
import TextEditorDisabled from '@web/conversations/Conversation/TextEditorDisabled/TextEditorDisabled';
import { useConversationDraftMessage } from '@web/conversations/DraftMessagesProvider/draftMessages.hooks';
import TextEditor from '@web/richText/TextEditor';

import { TextEditorErrorBoundary } from './TextEditorErrorBoundary';
import {
  useConversationTextEditor,
  useEditorActivityObserver,
} from './conversationTextEditor.hooks';

export const ConversationTextEditor = () => {
  const mentionPersonas = useConversationPersonas();
  const { id, onSubmit, isDisabled, withInactiveUser, editorRef } = useConversationTextEditor();
  const { draftMessage } = useConversationDraftMessage();

  const { onChange } = useEditorActivityObserver();

  if (isDisabled || withInactiveUser) {
    return <TextEditorDisabled withInactiveUser={withInactiveUser} />;
  }

  return (
    <TextEditorErrorBoundary>
      <TextEditor
        ref={editorRef}
        key={id}
        onContentChange={onChange}
        onSubmit={onSubmit}
        submitLabel={gettext('Send')}
        personas={mentionPersonas}
        initialValue={draftMessage.text}
      />
    </TextEditorErrorBoundary>
  );
};
